export default __webpack_public_path__ + "static/media/Breast pain.f98f1958.png";